import SideBySideTabsAndProcessTabsComponent from "./side-by-side-tabs-and-process-tabs-component";
import SideBySideTabsAndProcessTabsConfig from "./side-by-side-tabs-and-process-tabs-config";
import SideBySideTabsAndProcessTabsAdvancedConfig from "./side-by-side-tabs-and-process-tabs-advanced-config";

export default {
  SideBySideTabsAndProcessTabsComponent,
  SideBySideTabsAndProcessTabsConfig,
  SideBySideTabsAndProcessTabsAdvancedConfig
};
